module.exports = __webpack_public_path__ + "img/friend.72a6f3a.png";